import {
  getPresetIdFromDate,
  isCustomDateSelectorPreset,
} from '@app/components/date-range-selector/date-selector-presets';
import moment from 'moment-timezone';
import { SingleDateFilterValue } from './parse-as-single-date-filter';

/** Maps a calendar day to the URL-serializable single-date filter value used by ListView. */
export function dateToSingleDateFilterValue(date: Date, timezone: string): SingleDateFilterValue {
  const presetId = getPresetIdFromDate(date, timezone);

  return {
    presetId,
    ...(isCustomDateSelectorPreset(presetId) && {
      date: moment(date).tz(timezone).startOf('day').format('YYYY-MM-DD'),
    }),
  };
}
